module.exports = __webpack_public_path__ + "static/media/settings-info.382ba281.svg";